// const PAYMENT_API = "https://fetc.in/api/v1/payment";

// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// export const paymentApi = createApi({
//   reducerPath: "paymentApi",
//   tagTypes: ["Orders", "Refunds"],
//   baseQuery: fetchBaseQuery({
//     baseUrl: PAYMENT_API,
//     prepareHeaders: (headers, { getState }) => {
//       const token = getState().auth?.token;

//       if (token) {
//         headers.set("authorization", `Bearer ${token}`);
//       }

//       headers.set("Content-Type", "application/json");
//       return headers;
//     },
//   }),

//   endpoints: (builder) => ({
//     /* ================= PAYMENT ================= */

//     createOrder: builder.mutation({
//       query: ({ amount, phone, courseId, courseName, name, email }) => ({
//         url: "/initiate-payment",
//         method: "POST",
//         body: {
//           amount: Number(amount),
//           phone,
//           courseId,
//           courseName,
//           name,
//           email,
//           productType,
//         },
//       }),
//       invalidatesTags: ["Orders"],
//     }),

//     checkPaymentStatus: builder.query({
//       query: (transactionId) => `/status/${transactionId}`,
//       providesTags: (r, e, id) => [{ type: "Orders", id }],
//     }),

//     /* ================= USER ORDERS ================= */

//     getMyOrders: builder.query({
//       query: () => `/transactions`,
//       providesTags: ["Orders"],
//     }),

//     getOrderById: builder.query({
//       query: (transactionId) => `/transactions/${transactionId}`,
//       providesTags: (r, e, id) => [{ type: "Orders", id }],
//     }),

//     /* ================= ADMIN ================= */

//     getOrders: builder.query({
//       query: ({ status, page = 1, limit = 20 } = {}) => {
//         const params = new URLSearchParams();
//         params.append("page", page);
//         params.append("limit", limit);
//         if (status) params.append("status", status);

//         return `/transactions?${params.toString()}`;
//       },
//       providesTags: ["Orders"],
//     }),

//     deleteOrder: builder.mutation({
//       query: (transactionId) => ({
//         url: `/transactions/${transactionId}`,
//         method: "DELETE",
//       }),
//       invalidatesTags: ["Orders"],
//     }),

//     getTransactionStats: builder.query({
//       query: ({ startDate, endDate } = {}) => ({
//         url: "/transactions/stats",
//         params: { startDate, endDate },
//       }),
//       providesTags: ["Orders"],
//     }),

//     /* ================= REFUNDS ================= */

//     initiateRefund: builder.mutation({
//       query: ({ originalTransactionId, refundId, amount }) => ({
//         url: "/refund",
//         method: "POST",
//         body: {
//           originalTransactionId,
//           refundId,
//           amount: Number(amount),
//         },
//       }),
//       invalidatesTags: ["Orders", "Refunds"],
//     }),

//     getRefundStatus: builder.query({
//       query: (refundId) => `/refund/${refundId}`,
//       providesTags: (r, e, id) => [{ type: "Refunds", id }],
//     }),
//   }),
// });

// export const {
//   useCreateOrderMutation,
//   useCheckPaymentStatusQuery,
//   useGetOrdersQuery,
//   useGetMyOrdersQuery,
//   useGetOrderByIdQuery,
//   useInitiateRefundMutation,
//   useGetRefundStatusQuery,
//   useGetTransactionStatsQuery,
//   useDeleteOrderMutation,
// } = paymentApi;



const PAYMENT_API = "https://fetc.in/api/v1/payment";

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  tagTypes: ["Orders", "Refunds"],

  baseQuery: fetchBaseQuery({
    baseUrl: PAYMENT_API,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  endpoints: (builder) => ({

    /* ================= PAYMENT ================= */

    createOrder: builder.mutation({
  query: ({
    amount,
    phone,
    courseId,
    courseName,
    name,
    email,
    productType,
  }) => ({
    url: "/initiate-payment",
    method: "POST",
    body: {
      amount: Number(amount),
      phone,
      courseId,
      courseName,
      name,
      email,
      productType,
    },
  }),
}),
    /* ================= FREE ENROLL ================= */

    enrollCourse: builder.mutation({
      query: ({ courseId }) => ({
        url: "/enroll",
        method: "POST",
        body: { courseId },
      }),
      invalidatesTags: [{ type: "Orders", id: "LIST" }],
    }),

    /* ================= PAYMENT STATUS ================= */

    checkPaymentStatus: builder.query({
      query: (transactionId) => ({
        url: `/status/${transactionId}`,
        method: "GET",
      }),
    }),

    /* ================= USER ORDERS ================= */

    getMyOrders: builder.query({
      query: () => ({
        url: "/transactions",
        method: "GET",
      }),
      providesTags: [{ type: "Orders", id: "LIST" }],
    }),

    getOrderById: builder.query({
      query: (transactionId) => ({
        url: `/transactions/${transactionId}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [
        { type: "Orders", id },
      ],
    }),

    /* ================= ADMIN ================= */

    getOrders: builder.query({
      query: ({ status, page = 1, limit = 20 } = {}) => ({
        url: "/transactions",
        method: "GET",
        params: { status, page, limit },
      }),
      providesTags: [{ type: "Orders", id: "LIST" }],
    }),

    deleteOrder: builder.mutation({
      query: (transactionId) => ({
        url: `/transactions/${transactionId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Orders", id: "LIST" }],
    }),

    getTransactionStats: builder.query({
      query: ({ startDate, endDate } = {}) => ({
        url: "/transactions/stats",
        method: "GET",
        params: { startDate, endDate },
      }),
    }),

    
    /* ================= REFUNDS ================= */

    initiateRefund: builder.mutation({
      query: ({ originalTransactionId, refundId, amount }) => ({
        url: "/refund",
        method: "POST",
        body: {
          originalTransactionId,
          refundId,
          amount: Number(amount),
        },
      }),
      invalidatesTags: [
        { type: "Orders", id: "LIST" },
        { type: "Refunds", id: "LIST" },
      ],
    }),

    getRefundStatus: builder.query({
      query: (refundId) => ({
        url: `/refund/${refundId}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [
        { type: "Refunds", id },
      ],
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useEnrollCourseMutation,
  useCheckPaymentStatusQuery,
  useGetOrdersQuery,
  useGetMyOrdersQuery,
  useGetOrderByIdQuery,
  useInitiateRefundMutation,
  useGetRefundStatusQuery,
  useGetTransactionStatsQuery,
  useDeleteOrderMutation,
} = paymentApi;